<template>
  <div class="home">
    <!-- 开屏展示 -->
    <section class="hero-section">
      <div class="hero-content">
        <h1 class="hero-title">岐黄薪传网</h1>
        <p class="hero-slogan">传承中医药文化 涵养医者仁心</p>
      </div>
      <div class="hero-image">
        <img src="https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=600&h=400&fit=crop" alt="中医药传统文化" />
      </div>
    </section>

    <!-- 中医药文化影响展示 -->
    <section class="culture-impact">
      <h2 class="section-title">中医药文化对医学的深远影响</h2>
      
      <div class="impact-item">
        <div class="impact-content">
          <h3>仁心仁术 医者风范</h3>
          <p>中医药文化强调"医者仁心"，认为医者不仅要有精湛的医术，更要有仁爱之心。这种理念塑造了中国传统医学的职业道德标准，要求医务人员以患者为中心，体现出深厚的人文关怀。</p>
        </div>
        <div class="impact-image">
          <img src="https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=500&h=350&fit=crop" alt="中医诊疗" />
        </div>
      </div>

      <div class="impact-item reverse">
        <div class="impact-content">
          <h3>治未病 预防为先</h3>
          <p>"治未病"是中医药文化的核心理念，强调预防胜于治疗。这一思想影响了现代医学的预防医学理念，要求医务人员不仅要治病救人，更要注重疾病预防和健康教育。</p>
        </div>
        <div class="impact-image">
          <img src="https://images.unsplash.com/photo-1594824153793-8f7b7eb3c2c5?w=500&h=350&fit=crop" alt="中药材" />
        </div>
      </div>

      <div class="impact-item">
        <div class="impact-content">
          <h3>整体观念 辨证论治</h3>
          <p>中医药倡导整体观念和辨证论治，认为人体是一个有机整体，疾病的发生发展有其内在规律。这种思维方式培养了医务人员的系统性思维和个性化治疗能力。</p>
        </div>
        <div class="impact-image">
          <img src="https://images.unsplash.com/photo-1564121158271-8b87cc1c8ac7?w=500&h=350&fit=crop" alt="中医理论" />
        </div>
      </div>

      <div class="impact-item reverse">
        <div class="impact-content">
          <h3>德术并重 医道传承</h3>
          <p>中医药文化注重德术并重，认为医者必须具备高尚的品德和精湛的技艺。这种传统影响了现代医学教育，强调医德医风的培养，形成了独特的医学人文精神。</p>
        </div>
        <div class="impact-image">
          <img src="https://images.unsplash.com/photo-1607101776639-e8f7a87fd04a?w=500&h=350&fit=crop" alt="医学传承" />
        </div>
      </div>
    </section>

    <!-- 导航链接 -->
    <section class="navigation-section">
      <router-link to="/learning" class="nav-button">开始学习</router-link>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HomeView'
}
</script>

<style scoped>
.home {
  min-height: 100vh;
}

.hero-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 80vh;
  padding: 0 5%;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.hero-content {
  flex: 1;
  max-width: 500px;
}

.hero-title {
  font-size: 4rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.1);
}

.hero-slogan {
  font-size: 1.5rem;
  color: #34495e;
  font-weight: 300;
  line-height: 1.6;
}

.hero-image {
  flex: 1;
  max-width: 600px;
  margin-left: 2rem;
}

.hero-image img {
  width: 100%;
  height: auto;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}

.culture-impact {
  padding: 4rem 5%;
  background-color: #fff;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 3rem;
  font-weight: 600;
}

.impact-item {
  display: flex;
  align-items: center;
  margin-bottom: 4rem;
  gap: 3rem;
}

.impact-item.reverse {
  flex-direction: row-reverse;
}

.impact-content {
  flex: 1;
}

.impact-content h3 {
  font-size: 1.8rem;
  color: #e74c3c;
  margin-bottom: 1rem;
  font-weight: 600;
}

.impact-content p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
  text-align: justify;
}

.impact-image {
  flex: 1;
  max-width: 500px;
}

.impact-image img {
  width: 100%;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.navigation-section {
  text-align: center;
  padding: 3rem 0;
  background-color: #f8f9fa;
}

.nav-button {
  display: inline-block;
  padding: 15px 40px;
  background-color: #e74c3c;
  color: white;
  text-decoration: none;
  border-radius: 30px;
  font-size: 1.2rem;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(231, 76, 60, 0.3);
}

.nav-button:hover {
  background-color: #c0392b;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(231, 76, 60, 0.4);
}

@media (max-width: 768px) {
  .hero-section {
    flex-direction: column;
    text-align: center;
    padding: 2rem;
  }
  
  .hero-image {
    margin-left: 0;
    margin-top: 2rem;
  }
  
  .hero-title {
    font-size: 3rem;
  }
  
  .impact-item, .impact-item.reverse {
    flex-direction: column;
    text-align: center;
  }
  
  .culture-impact {
    padding: 2rem;
  }
}
</style>
